import { AttachmentRequestConfig, FileAttachment } from '../../db/types';
import AttachmentIcon from '../../icons/AttachmentIcon';
import { ToolbarButton } from '../../rich-text';
// import { FileAttachment } from "../../services/shared/types";
import UploadButton, { Props as UploadButtonProps } from '../UploadButton';

export interface Props<T extends Record<string, unknown>> {
  onUpload: (attachement: FileAttachment) => any;
  onUploadError?: (error: unknown) => any;
  requestConfig: AttachmentRequestConfig<T>;
}

const AttachButton = <T extends Record<string, unknown> = {}>({ requestConfig, onUpload, onUploadError }: Props<T>) => {
  const handleUpload: UploadButtonProps['onUpload'] = ({ name, originalName, type }) => {
    return onUpload({ name, originalName, extension: type });
  };

  return (
    <UploadButton accept="*" requestConfig={requestConfig} onUpload={handleUpload} onUploadError={onUploadError}>
      <ToolbarButton component="span">
        <AttachmentIcon />
      </ToolbarButton>
    </UploadButton>
  );
};

export default AttachButton;
